import React from 'react'

import type { AgentChatMessage } from '~/api/agentChat'

import { AgentMessageBubble } from './AgentMessageBubble'
import { UserMessageBubble } from './UserMessageBubble'

export interface ChatMessageProps {
  message: AgentChatMessage
  sessionId: string | null
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message, sessionId }) => {
  if (!message.content && !message.attachments?.length && !message.isLoading) {
    return null
  }

  if (message.sender === 'user') {
    return <UserMessageBubble message={message} />
  }

  return <AgentMessageBubble message={message} sessionId={sessionId} />
}

export default ChatMessage
